import styled, { css } from 'styled-components';

export const Container = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;

        @media ${theme.breakpoints.large.media} {
            flex-direction: row;
        }
    `}
`;

const BaseContainer = styled.div`
    ${({ theme }) => css`
        padding: 1rem 0.75rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 2rem 5.25rem;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 2rem 1.5rem;
        }
    `}
`;

export const ApplyContainer = styled(BaseContainer)`
    ${({ theme }) => css`
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        background: ${theme.colors.secondary.tints[0].hex};
        border-radius: 0.5rem 0.5rem 0 0;
        color: ${theme.colors.primary.hex};
        text-align: center;
        z-index: 2;

        @media ${theme.breakpoints.medium.media} {
            display: block;
            text-align: left;
        }

        @media ${theme.breakpoints.large.media} {
            border-radius: 0.5rem 0 0 0.5rem;
            display: block;
            width: 60%;
        }
    `}
`;

export const InputContainer = styled.div`
    ${({ theme }) => css`
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 0.5rem;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin-top: 1rem;
        }

        @media ${theme.breakpoints.large.media} {
            margin-top: 0;
        }
    `}
`;

export const OpenDayContainer = styled(BaseContainer)`
    ${({ theme }) => css`
        position: relative;
        width: 100%;
        background: ${theme.colors.accents[5].hex};
        color: ${theme.colors.primaryContrast.hex};
        display: grid;
        place-items: center;
        border-radius: 0 0 0.5rem 0.5rem;

        @media ${theme.breakpoints.large.media} {
            width: 40%;
            border-radius: 0 0.5rem 0.5rem 0;
        }
    `}
`;

export const Inner = styled.div`
    position: relative;
`;

const headingCss = ({ theme }) => css`
    font-size: 1.5rem;
    font-family: ${theme.fonts.secondary};
    font-weight: 300;

    @media ${theme.breakpoints.medium.media} {
        font-size: 2rem;
    }

    @media ${theme.breakpoints.large.media} {
        font-size: 1.75rem;
    }
`;

export const HeadingApplication = styled.h2`
    ${({ theme }) => css`
        ${headingCss};
        margin: 0 0 0.5rem;
        color: ${theme.colors.accents[5].hex};
    `}
`;

export const HeadingOpenDay = styled.h2`
    ${headingCss};
    margin: 0;
`;
